export default "__VITE_ASSET__3758397f__"